import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "@/lib/site";
import { copy } from "@/lib/content";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";

export const About = () => {
  const { lang } = useLang();
  const t = copy[lang];
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="tentang" ref={ref} data-testid="about-section" className="relative py-28 lg:py-40">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-5">
          <div className="relative mx-auto max-w-[420px]">
            <div className="aspect-[3/4] overflow-hidden rounded-[2rem] rounded-tl-[10rem] border border-amber-200/20">
              <motion.img style={{ y, scale: 1.18 }} src="/assets/rinda.jpg" alt="Rinda Marbun" className="h-full w-full object-cover object-top grayscale-[35%]" />
            </div>
            <p className="font-display absolute -bottom-6 right-4 sm:-right-6 rounded-2xl border border-amber-200/20 bg-[#0B1020] px-5 py-3 italic text-xl text-amber-200">{t.dedication}</p>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>{t.aboutEyebrow}</Eyebrow><SectionTitle lines={t.aboutTitle} testId="about-title" /></Reveal>
          <Reveal delay={0.1}>
            <p data-testid="about-bio" className="font-display mt-10 text-2xl sm:text-[1.85rem] leading-[1.35] text-slate-200">{t.bio}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3">
              {t.pills.map((p) => (
                <span key={p} className="rounded-full border border-amber-200/20 px-5 py-2.5 font-mono text-xs uppercase tracking-[0.18em] text-amber-100">{p}</span>
              ))}
            </div>
            <p className="font-signature mt-12 text-5xl text-gold">Rinda Marbun</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
